module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/catalogue/catalogue/catalogue.component.less
// module id = ./src/app/component/catalogue/catalogue/catalogue.component.less
// module chunks = common